import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { useErrorHandler } from "../custom-hooks/useErrorHandler";
import { StatusCodes } from "http-status-codes";

const ProtectedRoute = () => {
    const { user } = useAuth();
    const { isError } = useErrorHandler(StatusCodes.UNAUTHORIZED);

    if (!user || isError()) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
